import { Button, cn, Icon, Text } from '@mntn/ui-components'
import type { ReactNode } from 'react'

/**
 * NotificationBanner is a full-width dark strip with an icon, a message, an optional CTA and an
 * optional dismiss button. The parent owns dismissed state and spacing (margin) via `className`.
 */
export const NotificationBanner = ({
  icon,
  text,
  action,
  onDismiss,
  className,
}: {
  icon: ReactNode
  text: string
  /** Trailing CTA shown after the message, e.g. a text `<Button />`; rendered only when provided */
  action?: ReactNode
  /** Called when the dismiss button is clicked; the button renders only when provided */
  onDismiss?: () => void
  className?: string
}) => {
  return (
    <div className={cn('flex w-full items-center gap-2 bg-sub-surface-bg-inverse px-6 py-4', className)}>
      <span className="flex shrink-0 items-center">{icon}</span>
      <div className="flex flex-1 flex-wrap items-center gap-1">
        <Text variant="sm-sb" className="text-header-inverse">
          {text}
        </Text>
        {action}
      </div>
      {onDismiss && (
        <Button variant="text" aria-label="Dismiss" onClick={onDismiss} className="p-1 h-auto">
          <Icon name="X" className="size-4 text-header-inverse hover:opacity-60" />
        </Button>
      )}
    </div>
  )
}
